import { getIndustryLabel } from '../utils/industries';
import { answerCopy as budgetAnswerCopy, questionCopy as budgetQuestionCopy } from './BudgetStep';
import {
    answerCopy as deliverableAnswerCopy,
    questionCopy as deliverableQuestionCopy,
} from './DeliverableTypeStep';
import { questionCopy as industryStepQuestionCopy } from './IndustryStep';
import {
    answerCopy as primaryGoalAnswerCopy,
    questionCopy as primaryGoalQuestionCopy,
} from './PrimaryGoalStep';
import {
    answerCopy as stakeholderAnswerCopy,
    questionCopy as stakeholderQuestionCopy,
} from './StakeholderStep';
import {
    answerCopy as workingMethodAnswerCopy,
    questionCopy as workingMethodQuestionCopy,
} from './WorkingMethodStep';
import type { CurrencyCode } from '@99designs/i18n';
import type { StepResponse } from '../components/Onboarder/Config';
import type { Data } from './config';

export function getStepsResponse(data: Data, siteCurrency: CurrencyCode): StepResponse[] {
    const questionAnswers: StepResponse[] = [
        {
            question: stakeholderQuestionCopy(),
            answer: data.stakeholder ? stakeholderAnswerCopy()[data.stakeholder] : '',
        },
        {
            question: primaryGoalQuestionCopy(),
            answer: data.primaryGoal ? primaryGoalAnswerCopy()[data.primaryGoal] : '',
        },
        {
            question: industryStepQuestionCopy(),
            answer: data.industry ? getIndustryLabel(data.industry) : '',
        },
        {
            question: deliverableQuestionCopy(),
            answer: data.deliverableType ? deliverableAnswerCopy()[data.deliverableType] : '',
        },
    ];

    if (data.budget) {
        questionAnswers.push({
            question: budgetQuestionCopy(),
            answer: budgetAnswerCopy(data.budget, siteCurrency),
        });
    } else if (data.workingMethod) {
        questionAnswers.push({
            question: workingMethodQuestionCopy(),
            answer: workingMethodAnswerCopy()[data.workingMethod],
        });
    }

    return questionAnswers;
}
